import * as React from 'react'
import { Form, ListGroup } from 'react-bootstrap'

interface Props {
  name: string
  items: InputRadioItem[]
  checked?: string
  defaultCheckedValue?: string
  className?: string
  style?: React.CSSProperties
  label?: string
  bold?: boolean
  setValue?: (value: string) => void
  onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void
  ariaControls?: string
}

/**
 * ラジオボックス項目
 */
export interface InputRadioItem {
  label: string
  value: string
}

const Component: React.FC<Props> = ({ name, items, checked, defaultCheckedValue, className, style, label, bold, setValue, onChange, ariaControls }) => {
  const originalOnChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (setValue) {
      setValue(event.target.value)
    }
    if (onChange) {
      onChange(event)
    }
  }
  const checkItems = []
  for (let i = 0; i < items.length; i++) {
    const { label, value } = items[i]
    checkItems.push(
      <Form.Check key={i}>
        <Form.Label className="w-100">
          <ListGroup.Item className="mt-1 rounded py-3">
            <Form.Check
              id={`radio-${name}-${i}`}
              type="radio"
              name={name}
              value={value}
              label={label}
              checked={checked != null ? checked === value : undefined}
              defaultChecked={defaultCheckedValue != null ? defaultCheckedValue === value : undefined}
              onChange={originalOnChange}
              aria-controls={ariaControls}
            />
          </ListGroup.Item>
        </Form.Label>
      </Form.Check>,
    )
  }
  return (
    <div id={`input_item_id_${name}`} className={className} style={style}>
      {label && <div className={`font-15${bold ? ' fw-bold' : ''}`}>{label}</div>}
      <ListGroup variant="flush">{checkItems}</ListGroup>
    </div>
  )
}

export default Component
